'use client';

import { usePathname } from 'next/navigation';

import { expertAdviceCategories } from '../../categoriesData';

import { HeadingText } from '@/components/atoms/HeadingText';
import { SpaceWow } from '@/components/SpaceWow';
import { CategoriesMenu } from '../CategoriesMenu';

export interface LearnMoreMenuProps {
	testId?: string;
}

const LearnMoreMenu = (props: LearnMoreMenuProps) => {
	const { testId = 'LearnMoreMenu' } = props;
	const currentPath = usePathname();

	const filteredCategories = expertAdviceCategories.filter(
		(cat) => cat.slug !== currentPath,
	);

	return (
		<section data-testid={testId} className="hvac-container">
			<SpaceWow spacer_10 lg__spacer_20 />
			<HeadingText tag="h3" size="h2" className="-lg:text-2xl">
				Learn more
			</HeadingText>
			<SpaceWow spacer_06 lg__spacer_14 />
			<CategoriesMenu categories={filteredCategories} />
			<SpaceWow spacer_10 lg__spacer_20 />
		</section>
	);
};

export default LearnMoreMenu;
